export default {"src":"/_next/static/media/wheel_spin_outer_slow.3e4a683a.gif","height":900,"width":900};